export default __webpack_public_path__ + "static/train-station-f65b1696dcece97cef4ec755035ca248.jpg";